module.exports = __webpack_public_path__ + "static/img14-f52be3050ab096b6379a81d44cfb0b0c.jpg";